import { createCookie, eraseCookie, readCookie } from 'utils/cookies';

import Constants from 'utils/Constants';
import { createSlice } from '@reduxjs/toolkit';

const initialState = () => {
  let access_token = readCookie(Constants.ACCESS_TOKEN);
  let user;
  try {
    user = JSON.parse(readCookie(Constants.ACCOUNT_DATA) || '{}');
  } catch (error) {
    user = {};
  }
  return {
    hasFetched: false,
    isFetching: false,
    isLogin: access_token ? access_token : false,
    data: user,
  };
};

const userReducers = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetApp: () => {
      eraseCookie(Constants.ACCESS_TOKEN);
      return initialState();
    },
    setLogin: (state, action) => {
      state.isLogin = true;
      createCookie(Constants.ACCESS_TOKEN, action.payload.access_token, 1);
      createCookie(
        Constants.ACCOUNT_DATA,
        JSON.stringify(action.payload.user),
        1,
      );
      return state;
    },
    receiveUser: (state, action) => {
      state.hasFetched = true;
      state.isFetching = false;
      state.data = action.payload;
      return state;
    },
    logoutUser: () => {
      eraseCookie(Constants.ACCESS_TOKEN);
      eraseCookie(Constants.ACCOUNT_DATA);
      return initialState();
    },
  },
});
export const { resetApp, setLogin, receiveUser, logoutUser } =
  userReducers.actions;
export default userReducers.reducer;
